import { loginFailure, loginStart, loginSuccess } from "./userRedux";
import config from "../config";
import axios from "axios";
import { toast } from "react-toastify";

/*
  POURQUOI toast ET NON message d'antd, ICI PRÉCISÉMENT.

  Le correctif #147 (15/07) a rendu les notifications fiables dans la WebView
  Android : celle-ci gèle les animations CSS au retour d'arrière-plan, et
  react-toastify démarre son entrée à opacity:0 — un toast gelé à sa première
  frame est donc INVISIBLE. Le correctif neutralise cette animation
  (utils/toastTransition.jsx), mais il ne touche QUE react-toastify.

  Le `message` d'antd a exactement le même mode d'échec : son keyframe d'entrée
  démarre lui aussi à opacity:0 (antd/lib/message/style/index.js), sans aucun
  garde-fou temporel. Or l'écran de login est PRÉCISÉMENT celui du retour
  d'arrière-plan — le déclencheur exact du gel documenté par #147. Un livreur
  dont la connexion échoue ne voyait potentiellement rien : ni le motif, ni quoi
  faire.

  Réserve : le gel n'a pas été observé sur device pour le moteur antd ; il l'a
  été pour l'autre. On sécurise le chemin le plus exposé, pas toute l'app.
  Les 62 autres appels `message.*` restent sur antd (arbitrage du propriétaire,
  17/07) — ils ne sont pas sur le trajet du retour d'arrière-plan.
*/

export const login = async (dispatch, user, navigate) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

  dispatch(loginStart());
  try {
    const res = await axios.post(`${DOMAIN}/api/auth/login`, user);
    // Ne poser currentUser QUE si le login a réussi. Avant, loginSuccess était
    // dispatché même sur échec (success:false) → currentUser devenait l'objet
    // d'erreur { message, success:false }, sans token ni id (session fantôme).
    if (res.data.success) {
      dispatch(loginSuccess(res.data));
      toast.success("Connectez-vous avec succès");
      navigate('/');
    } else {
      dispatch(loginFailure());
      toast.error(res.data.message);
    }
  } catch (err) {
    dispatch(loginFailure());
    // Erreur réseau (requête partie mais aucune réponse) vs erreur serveur.
    if (err?.request && !err?.response) {
      toast.error('Serveur injoignable — vérifiez votre connexion');
    } else {
      toast.error('Connexion impossible (erreur serveur)');
    }
  }
};

export const register = async (dispatch, user) => {
  const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

  dispatch(loginStart());
  try {
    const res = await axios.post(`${DOMAIN}/api/auth/register`, user);
    // Même correctif que login : ne poser currentUser que si succès.
    if (res.data.success) {
      dispatch(loginSuccess(res.data));
      toast.success("Connectez-vous avec succès");
    } else {
      dispatch(loginFailure());
      toast.error(res.data.message);
    }
  } catch (err) {
    dispatch(loginFailure());
    console.log(err);
    toast.error("Quelque chose s'est mal passé");
  }
};

